<template>
  <div class="summary">
    <span v-if="pricingPeriod === 'monthly'">
      {{plan.name}} plan with {{ learners.length }} Learner(s) at
      <span :class="{ 'discount-strikethrough': discountActive}">
        ${{ unitPrice.toFixed(2) }}
      </span>
      <span v-if="discountActive"
        >&nbsp;${{ unitPriceWithDiscountCode.toFixed(2) }}</span
      >
      {{$t("message.each-per-month")}}{{currentSubscription ? `, ${ $t("message.taking-effect", [effectDate])}` : ''}}
      <span
        class="proviso"
        v-if="proviso"
        v-html="proviso"
      ></span>
    </span>
    <span v-else>
      {{plan.name}} plan with {{ licenceCount }} {{ $t("message.licenses-at") }}
      <span :class="{ 'discount-strikethrough': discountActive}">
        ${{ unitPrice.toFixed(2) }}
      </span>
      <span v-if="discountActive"
        >&nbsp;${{ unitPriceWithDiscountCode.toFixed(2) }}</span
      >
      {{$t("message.each-per-year")}}{{currentSubscription ? `, ${ $t("message.taking-effect", [effectDate])}` : ''}}
      <span
        class="proviso"
        v-if="proviso && !allowEdit"
        v-html="proviso"
      ></span>
    </span>
    <p class="edit" v-if="allowEdit">
      <a
        href=""
        @click.prevent="()=>{if (!paymentProcessing) $emit('switchPage', 'selectPlan')}"
        >{{ $t("message.edit") }}</a
      >
    </p>
    <p v-if="updateNow"> {{ $t("message.pro-rata-discount-summary", [proRataDiscount.toFixed(2), (proRataDiscount / seats).toFixed(2)]) }}</p>
    <p v-if="cancelScheduled"> {{ $t("message.plan-changes-cancelled") }}</p>
    <p class="total">
      <span :class="{ 'discount-strikethrough': discountActive || updateNow}">
        ${{ totalPrice }}
      </span>
      <span v-if="discountActive || updateNow"
        >&nbsp;${{ (finalPrice / 100).toFixed(2)}}</span
      >
      {{ $t("message.total-due") }} {{effectDate}}
    </p>
  </div>
</template>

<style lang="less" scoped>
.summary {
  margin-top: 2.5em;
  p {
    padding-bottom: 0px;
    a {
      color: #333;
      background: #ccc;
      border-radius: 999px;
      padding: 3px 9px 5px 9px;
      margin-left: 8px;
      position: relative;
    }
  }
  .discount-strikethrough {
    text-decoration: line-through;
  }
  .total {
    font-weight: bold;
  }
  .edit {
    display: inline;
    width: fit-content;
    a {
      text-decoration: none;
    }
  }
}
</style>

<script>
  import { mapState, mapGetters } from "vuex";

  export default {
    props: ["allowEdit"],
    computed: {
      ...mapGetters([
        "discountActive",
        "unitPrice",
        "unitPriceWithDiscountCode",
        "seats",
        "updateNow",
        "finalPrice",
        "totalPrice",
        "proRataDiscount",
        "cancelScheduled"
      ]),
      ...mapState({
        licenceCount: state => state.payment.licenceCount,
        learners: state => state.payment.learners,
        proviso: state => state.payment.proviso,
        plan: state => state.payment.plan,
        discount: state => state.payment.discount,
        pricingPeriod: state => state.payment.pricingPeriod,
        paymentProcessing: state => state.payment.paymentProcessing,
        currentSubscription: state => state.payment.currentSubscription
      }),
      effectDate() {
        if (!this.currentSubscription) {
          return "today";
        } else if (this.updateNow) {
          return this.$t("message.immediately");
        } else if (this.currentSubscription && this.currentSubscription.billing) {
          return this.$t("message.on-date", [this.$moment(this.currentSubscription.billing.next_payment_due).format("MMM Do, Y")]);
        } else {
          return this.$t("message.at-start-of-next-billing");
        }
      },
    }
  }
</script>
